export default function (file) {
  return new Promise((resolve, reject) => {
    import('compressorjs').then((mod) => {
      const Compressor = mod.default
      // eslint-disable-next-line no-new
      new Compressor(file, {
        quality: 0.6,
        strict: true,
        convertSize: 4000000,
        success (result) {
          resolve(result)
        },
        error (err) {
          console.log(err)
          reject(err)
        }
      })
    }).catch((e) => {
      reject(e)
    })
  })
}
